<div class="input-container">
  <label [for]="id">{{labelText}}</label>
  <input [type]="inputType" [formControlName]="formControlName" [id]="id">
  <div *ngIf="optional">
    <input type="checkbox" [id]="id  + '-select'">
    <label [for]="id  + '-select'">No disponible</label>
  </div>
</div>
